import { Z } from "./query";

export class ContainedDragEvent extends Event {

    type: string;
    x: number;
    y: number;
    initialX: number;
    initialY: number;

    isInsideElement: boolean;

    get deltaX() {
        return this.x - this.initialX;
    }
    get deltaY() {
        return this.y - this.initialY;
    }
    get delta() {
        return Math.sqrt(this.deltaX * this.deltaX + this.deltaY * this.deltaY);
    }

    get lockedDeltaX() {
        if (Math.abs(this.deltaX) > Math.abs(this.deltaY)) {
            return this.deltaX;
        }
        return 0;
    }
    get lockedDeltaY() {
        if (Math.abs(this.deltaY) > Math.abs(this.deltaX)) {
            return this.deltaY;
        }
        return 0;
    }

    get lockedX() {
        if (Math.abs(this.deltaX) > Math.abs(this.deltaY)) {
            return this.x;
        }
        return this.initialX;
    }
    get lockedY() {
        if (Math.abs(this.deltaY) > Math.abs(this.deltaX)) {
            return this.y;
        }
        return this.initialY;
    }
    get lockableDeltaX() {
        return this.shiftKey ? this.lockedDeltaX : this.deltaX;
    }
    get lockableDeltaY() {
        return this.shiftKey ? this.lockedDeltaY : this.deltaY;
    }
    get lockableX() {
        return this.shiftKey ? this.lockedX : this.x;
    }
    get lockableY() {
        return this.shiftKey ? this.lockedY : this.y;
    }

    button: number;
    shiftKey: boolean = false;
    ctrlKey: boolean = false;
    altKey: boolean = false;

    constructor(type: string, x: number, y: number, also: any = null) {
        super(type);
        this.x = x;
        this.y = y;

        this.initialX = x;
        this.initialY = y;

        if (also) {
            Object.assign(this, also);
        }
    }

}

export class ContainedDragListener {
    element: HTMLElement;
    containerElement: HTMLElement;
    dragging: boolean = false;
    dragOriginX: number;
    dragOriginY: number;

    LogModule: boolean = false;

    constructor(element: HTMLElement) {
        this.element = element;

        if (element.dataset.containment)
            this.containerElement = element.querySelector(element.dataset.containment) as HTMLElement;

        if (!this.containerElement)
            this.containerElement = this.element;

        element.addEventListener('mousedown', ev => this.mouseDown(ev));
        window.addEventListener('mousemove', ev => this.windowMouseMove(ev));
        window.addEventListener('mouseup', ev => this.windowMouseUp(ev));
        document.addEventListener('mouseleave', ev => this.windowMouseOut(ev));

        element.addEventListener('touchstart', ev => this.touchStart(ev), { passive: false });
        window.addEventListener('touchmove', ev => this.windowTouchMove(ev));
        element.addEventListener('touchend', ev => this.windowTouchEnd(ev));
    }

    mouseDown(ev: MouseEvent) {
        this.dragging = true;

        let bounds = this.containerElement.getBoundingClientRect();
        let x = (ev.clientX - bounds.x) / bounds.width;
        let y = (ev.clientY - bounds.y) / bounds.height;

        this.dragOriginX = x;
        this.dragOriginY = y;

        ev.preventDefault();
        ev.stopPropagation();

        if (ev.target == this.element) {
            document.querySelectorAll('.context-menu.active')
                .forEach(cm => cm.classList.remove('active'));

            document.querySelectorAll('.gui-popup.active')
                .forEach(gui => {
                    if (gui.contains(this.element)) return;
                    if (gui.contains(this.containerElement)) return;
                    gui.classList.remove('active');
                });
        }

        this.element.dispatchEvent(<Event>new ContainedDragEvent('cursor-start', x, y, {
            button: ev.button,
            ctrlKey: ev.ctrlKey,
            altKey: ev.altKey,
            shiftKey: ev.shiftKey,
        }));
    }
    windowMouseMove(ev: MouseEvent) {

        let bounds = this.containerElement.getBoundingClientRect();
        let x = (ev.pageX - bounds.x) / bounds.width;
        let y = (ev.pageY - bounds.y) / bounds.height;

        if (this.dragging) {
            let within = true;
            if (x < 0) { x = 0; within = false; }
            if (y < 0) { y = 0; within = false; }
            if (x > 1) { x = 1; within = false; }
            if (y > 1) { y = 1; within = false; }
            ev.preventDefault();
            ev.stopPropagation();

            this.element.dispatchEvent(<Event>new ContainedDragEvent('cursor-move', x, y, {
                button: ev.button,
                initialX: this.dragOriginX,
                initialY: this.dragOriginY,
                ctrlKey: ev.ctrlKey,
                altKey: ev.altKey,
                shiftKey: ev.shiftKey,
                isInsideElement: within,
            }));
        } else {
            if (x >= 0 && x <= 1) {
                if (y >= 0 && y <= 1) {
                    this.element.dispatchEvent(<Event>new ContainedDragEvent('cursor-hover', x, y, {
                        button: null,
                        ctrlKey: ev.ctrlKey,
                        altKey: ev.altKey,
                        shiftKey: ev.shiftKey,
                        isInsideElement: true,
                    }));
                }
            }
        }
    }
    windowMouseUp(ev: MouseEvent) {
        this.dragging = false;

        let bounds = this.containerElement.getBoundingClientRect();
        let x = (ev.pageX - bounds.x) / bounds.width;
        let y = (ev.pageY - bounds.y) / bounds.height;
        let within = true;
        if (x < 0) { x = 0; within = false; }
        if (y < 0) { y = 0; within = false; }
        if (x > 1) { x = 1; within = false; }
        if (y > 1) { y = 1; within = false; }

        this.element.dispatchEvent(<Event>new ContainedDragEvent('cursor-stop', x, y, {
            button: ev.button,
            ctrlKey: ev.ctrlKey,
            altKey: ev.altKey,
            shiftKey: ev.shiftKey,
            isInsideElement: within,
            initialX: this.dragOriginX, initialY: this.dragOriginY
        }));
    }
    windowMouseOut(ev: MouseEvent) {
        if (this.dragging) {
            this.dragging = false;
        }
    }

    longTapTimeout: any = null;
    longTapX: number = null;
    longTapY: number = null;
    checkTimeout() {
        let bounds = this.element.getBoundingClientRect();

        this.element.dispatchEvent(<Event>new MouseEvent('contextmenu', {
            clientX: this.longTapX + bounds.x,
            clientY: this.longTapY + bounds.y,
            movementX: 0,
            movementY: 0,
            button: 2,
            screenX: this.longTapX,
            screenY: this.longTapY,
        }));
    }

    touchStart(ev: TouchEvent) {
        this.dragging = true;

        let bounds = this.containerElement.getBoundingClientRect();
        let x = (ev.touches[0].clientX - bounds.x) / bounds.width;
        let y = (ev.touches[0].clientY - bounds.y) / bounds.height;
        this.dragOriginX = x;
        this.dragOriginY = y;

        this.longTapTimeout = setTimeout(() => this.checkTimeout(), 1000);
        this.longTapX = x * bounds.width;
        this.longTapY = y * bounds.height;

        ev.preventDefault();

        this.element.dispatchEvent(<Event>new ContainedDragEvent('cursor-start', x, y, { button: 0 }));

        ev.stopPropagation();

        if (ev.target == this.element) {
            document.querySelectorAll('.context-menu.active')
                .forEach(cm => cm.classList.remove('active'));

            document.querySelectorAll('.gui-popup.active')
                .forEach(gui => {
                    if (gui.contains(this.element)) return;
                    if (gui.contains(this.containerElement)) return;
                    gui.classList.remove('active');
                });
        }

    }
    windowTouchMove(ev: TouchEvent) {
        if (this.dragging) {

            let bounds = this.containerElement.getBoundingClientRect();
            let x = (ev.changedTouches[0].pageX - bounds.x) / bounds.width;
            let y = (ev.changedTouches[0].pageY - bounds.y) / bounds.height;
            let within = true;
            if (x < 0) { x = 0; within = false; }
            if (y < 0) { y = 0; within = false; }
            if (x > 1) { x = 1; within = false; }
            if (y > 1) { y = 1; within = false; }
            ev.preventDefault();
            ev.stopPropagation();

            let newTapX = x * bounds.width;
            let newTapY = y * bounds.height;

            let deltaX = newTapX - this.longTapX;
            let deltaY = newTapY - this.longTapY;
            let delta = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

            if (delta > 30)
                clearTimeout(this.longTapTimeout);

            this.element.dispatchEvent(<Event>new ContainedDragEvent('cursor-move', x, y, {
                button: 0, initialX: this.dragOriginX, initialY: this.dragOriginY, isInsideElement: within
            }));
        }
    }
    windowTouchEnd(ev: TouchEvent) {
        if (this.dragging) {
            let bounds = this.containerElement.getBoundingClientRect();
            let x = (ev.changedTouches[0].pageX - bounds.x) / bounds.width;
            let y = (ev.changedTouches[0].pageY - bounds.y) / bounds.height;
            let within = true;
            if (x < 0) { x = 0; within = false; }
            if (y < 0) { y = 0; within = false; }
            if (x > 1) { x = 1; within = false; }
            if (y > 1) { y = 1; within = false; }
            ev.preventDefault();
            ev.stopPropagation();

            this.element.dispatchEvent(<Event>new ContainedDragEvent('cursor-stop', x, y, { button: 0, initialX: this.dragOriginX, initialY: this.dragOriginY, isInsideElement: within }));
        }
        this.dragging = false;

        clearTimeout(this.longTapTimeout);
    }


}